import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./DeIceApronHeaterStatus.scss";
import { ClockIcon } from "@navikt/aksel-icons";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { prettyPrintDate } from "@utils/DateUtils";
import NoDataAvailable from "@components/NoDataAvailable/NoDataAvailable";
import PowerOnIcon from "@components/PowerOnIcon/PowerOnIcon";
import Spinner from "@components/Spinner/Spinner";
import { useIataContext } from "@contexts/IataContext";
import { getApronHeaterStatus, saveApronHeaterStatus } from "../services";
import SvgHeater from "./Heater";
export const DeIceApronHeaterStatus = ({ date }) => {
    const { t } = useTranslation();
    const { iata } = useIataContext();
    const { i18n } = useTranslation();
    const queryClient = useQueryClient();
    const [apronHeaterStatus, setApronHeaterStatus] = useState();
    const { data: apronHeaterStatusData, isLoading } = useQuery({
        queryFn: () => getApronHeaterStatus({
            date,
            iata,
        }),
        queryKey: ["apronHeaterStatusData", { date, iata }],
    });
    const saveApronHeaterStatusMutation = useMutation({
        mutationFn: ({ iata, apronHeaterStatus }) => saveApronHeaterStatus({
            body: {
                iata,
                apronHeaterStatus,
            },
        }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["apronHeaterStatusData"] });
        },
        onError: (error) => {
            console.error(`saveApronHeaterStatus() ERROR \n${error}`);
        },
    });
    useEffect(() => {
        if (apronHeaterStatusData && apronHeaterStatusData.length > 0) {
            // Find the latest entry by comparing updatedAt
            const latestEntry = apronHeaterStatusData.reduce((latest, current) => new Date(current.updatedAt) > new Date(latest.updatedAt) ? current : latest);
            // Set the apronHeaterStatus based on the latest entry
            setApronHeaterStatus(latestEntry);
        }
    }, [apronHeaterStatusData]);
    if (isLoading || saveApronHeaterStatusMutation.isPending) {
        return _jsx(Spinner, {});
    }
    if (!apronHeaterStatus) {
        return _jsx(NoDataAvailable, {});
    }
    return (_jsxs("div", { className: apronHeaterStatus.apronHeaterStatus ? "widget-apron-heater widget-apron-heater-on" : "widget-apron-heater widget-apron-heater-off", children: [_jsxs("div", { className: "power-body", children: [_jsx("div", { className: apronHeaterStatus.apronHeaterStatus ? "power-diode power-diode-on" : "power-diode power-diode-off", children: _jsx(PowerOnIcon, { width: "2.5em", height: "2.5em" }) }), _jsxs("div", { className: "power-display", children: [_jsx("div", { className: "power-display-label", children: apronHeaterStatus.apronHeaterStatus ? t("deice.apronHeater.on") : t("deice.apronHeater.off") }), _jsxs("div", { className: "power-display-time", children: [_jsx(ClockIcon, { title: "a11y-title", fontSize: "1rem" }), prettyPrintDate(apronHeaterStatus.updatedAt, i18n.language)] })] })] }), _jsx("div", { className: apronHeaterStatus.apronHeaterStatus ? "fade-animation-on" : "fade-animation-off", children: _jsx(SvgHeater, { width: "3em", height: "3em" }) })] }));
};
